//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import M_TRA_BASIC_03 from './M_TRA_BASIC_03';
import { Loading } from '../../../../../Components/MUIs';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Global from '../../../../../Services/Common/Global';
import { PDFDocument } from 'pdf-lib';
import { BottomSheetActions } from '../../../../../Reducer/BottomSheetReducer';
import { showSnackbar } from '../../../../../Reducer/SnackbarReducer';
import Commons from '../../../../../Services/Common/Common';
import { NavBarInfoActions } from '../../../../../Reducer/NavBarInfoReducer';
import { useAppNavigate } from '../../../../../Hooks/back/useAppNavigate';
import { useBackStack } from '../../../../../Hooks/back/useBackStack';
//#endregion

function M_TRA_BASIC_03F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const { navigate } = useAppNavigate();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  // 사업장 선택 상태
  const [custInfo, setCustInfo] = useState({
    custList: [],
    custCd: '',
  });

  // 파일 업로드 상태
  const [videoFile, setVideoFile] = useState(null); // 동영상 파일 객체
  const [videoUrl, setVideoUrl] = useState(null); // 서버에서 불러온 동영상 URL
  const [materialFile, setMaterialFile] = useState(null); // 교육 자료 파일 객체
  const [previewUrl, setPreviewUrl] = useState(null); // 교육 자료 미리보기 URL

  // 4단계 부서 선택 상태
  const [selectedHeadquarters, setSelectedHeadquarters] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedParts, setSelectedParts] = useState([]);

  // 부서 데이터 구조 (API에서 로드됨)
  const [departmentData, setDepartmentData] = useState({
    headquarters: [],
    departments: [],
    teams: [],
    parts: [],
  });

  // refs
  const videoInputRef = useRef(null);
  const materialInputRef = useRef(null);
  const searchRef = useRef({
    custList: [],
    custCd: '',
  });

  const ToggleDrawer = (anchor, open) => () => {
    dispatch(
      BottomSheetActions.SetBottomSheetState({
        bottom: open,
        type: open ? bottomSheetState?.type : bottomSheetState?.type,
      })
    );
  };
  //#endregion

  // 스택형 뒤로가기로 변경: 교육 자료 등록 이탈 시 확인 시트 표시
  useBackStack({
    type: 'sheet',
    enabled: !bottomSheetState.bottom,
    onBack: () =>
      dispatch(BottomSheetActions.OpenBottomSheet({ type: 'backClickTra' })),
  });

  useEffect(() => {
    Init();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const Init = async () => {
    setLoading(true);
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('교육 자료 등록'));

    try {
      await SearchCust();
      await SearchLogic1();
      id && (await SearchLogic2(id));
    } catch (e) {
      console.log('Error: ', e);
      dispatch(
        showSnackbar({
          message: '초기화 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };

  //#region 조회
  //사업장정보 조회
  const SearchCust = async () => {
    setLoading(true);
    try {
      const result = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_GET_AUTH_CUST_MANAGER',
            _USER_ID: userInfo.userid, // 사용자 ID
            _AUTH_CD: Commons.EncryptAES(userInfo.authCd) || '', // 권한코드
          },
        ]
      );
      let data = result.data;
      let changeData = [];

      if (data.length === 0) {
        setCustInfo({
          custList: [],
          custCd: '',
        });
        searchRef.current = {
          custList: [],
          custCd: '',
        };
      } else if (data[0]?.type === 'Error') {
        //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
        dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
        return false;
      } else {
        data.forEach((_item) => {
          changeData.push({
            value: _item.custCd,
            name: _item.custNm,
          });
        });
        // setSelectedChip(changeData[0]);
        setCustInfo({
          ...custInfo,
          custList: changeData,
          custCd: changeData[0].value,
        });
        searchRef.current = {
          ...searchRef.current,
          custList: changeData,
          custCd: changeData[0].value,
        };
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  // 전체본부 리스트 조회
  const SearchLogic1 = async () => {
    setDepartmentData({
      headquarters: [],
      departments: [],
      teams: [],
      parts: [],
    });
    setSelectedHeadquarters([]);
    setSelectedDepartments([]);
    setSelectedTeams([]);
    setSelectedParts([]);

    try {
      await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TRA_BASIC_04_R3',
            _CUST_CD: Commons.EncryptAES(searchRef.current.custCd) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length === 0) {
          dispatch(
            showSnackbar({
              message: data[0]?.message || '부서가 없습니다.',
              type: 'info',
            })
          );
        } else if (data[0]?.type === 'Error') {
          dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
          return false;
        } else {
          const convertedData = ConvertDepartmentData(data);
          setDepartmentData(convertedData); //전체부서 세팅
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
    }
  };

  // 수정시 해당 부서 정보 조회 ( 동영상, 교육자료 )
  const SearchLogic2 = async (_depCd) => {
    try {
      const result = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TRA_BASIC_04_R2',
            _DEP_CD: Commons.EncryptAES(_depCd) || '',
          },
        ]
      );

      const data = result.data;

      if (!data || data.length === 0 || data[0]?.type === 'Error') {
        dispatch(
          showSnackbar({
            message: data[0]?.message || '데이터가 없습니다.',
            type: 'info',
          })
        );
        setPreviewUrl('');
        setVideoFile(null);
        setVideoUrl(null);
        return;
      }

      // 사업장 코드 업데이트
      setCustInfo({
        ...custInfo,
        custList: searchRef.current.custList,
        custCd: data[0].CUST_CD,
      });
      searchRef.current = {
        ...searchRef.current,
        custList: searchRef.current.custList,
        custCd: data[0].CUST_CD,
      };

      /** 부서 선택 처리 */
      const depNm1 = data[0].DEP_NM1;
      const depNm2 = data[0].DEP_NM2;
      const depNm3 = data[0].DEP_NM3;
      const depNm4 = data[0].DEP_NM4;

      // 부서 계층 구조에 따라 선택 상태 설정
      if (depNm1) {
        setSelectedHeadquarters([depNm1]);

        if (depNm2) {
          const deptKey = `${depNm1}-${depNm2}`;
          setSelectedDepartments([deptKey]);

          if (depNm3) {
            const teamKey = `${depNm1}-${depNm2}-${depNm3}`;
            setSelectedTeams([teamKey]);

            if (depNm4) {
              const partKey = `${depNm1}-${depNm2}-${depNm3}-${depNm4}`;
              setSelectedParts([partKey]);
            }
          }
        }
      }

      /** 교육 자료 처리 */
      const eduPath = data[0].EDU_LOCATION || '';
      const eduFixedUrl = FixUrl(eduPath);
      setPreviewUrl(eduFixedUrl);

      /** 비디오 파일 처리 */
      const videoPath = data[0].VIDEO_LOCATION || '';
      const videoFullUrl = GetFullFileUrl(videoPath);
      setVideoFile(null); // 서버에서 불러왔을 땐 로컬 업로드된 파일 초기화
      setVideoUrl(videoFullUrl); // 서버에서 불러온 동영상 URL 설정
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
    }
  };
  //#endregion
  //#region 저장
  // 교육 자료 저장
  const HandleSave = async () => {
    setLoading(true);
    try {
      const depCdList = GetExportDepCds();

      // 기존 파일 경로 및 이름 저장용 객체
      const existingVideoPaths = {};
      const existingEduPaths = {};
      const existingVideoNames = {};
      const existingEduNames = {};

      // 저장 전에 기존 경로 가져오기
      for (const depCd of depCdList) {
        const reqData = [
          {
            procedureName: 'SP_TRA_BASIC_04_R2',
            _DEP_CD: Commons.EncryptAES(depCd),
          },
        ];

        const result = await Commons.Axios(
          'post1',
          Global.base.useUrl + Global.urls.Execute.execute,
          reqData
        );

        const data = result?.data?.[0];
        if (data) {
          existingVideoPaths[depCd] = data.VIDEO_LOCATION || '';
          existingEduPaths[depCd] = data.EDU_LOCATION || '';
          existingVideoNames[depCd] = data.VIDEO_FILE_NAME || '';
          existingEduNames[depCd] = data.EDU_FILE_NAME || '';
        }
      }

      for (const depCd of depCdList) {
        //DB저장용 경로(파일name포함)
        const videoPath = videoFile
          ? `Video/${searchRef.current.custCd}/${depCd}/DEP_BASIC/${videoFile.name}`
          : existingVideoPaths[depCd];
        const eduPath = materialFile
          ? `Education/${searchRef.current.custCd}/${depCd}/DEP_BASIC/${materialFile.name}`
          : existingEduPaths[depCd];

        //서버저장용 경로(파일name빼고)
        const videoPathServer = `Video/${searchRef.current.custCd}/${depCd}/DEP_BASIC`;
        const eduPathServer = `Education/${searchRef.current.custCd}/${depCd}/DEP_BASIC`;

        // DB 저장 호출
        await saveToDB(
          depCd,
          videoFile ? videoFile.name : existingVideoNames[depCd],
          videoPath,
          materialFile ? materialFile.name : existingEduNames[depCd],
          eduPath
        );

        // 파일서버에 동영상 업로드
        videoFile &&
          (await SaveLogic2(
            videoPathServer,
            videoFile,
            existingVideoPaths[depCd]
          ));

        // 파일서버에 교육자료 업로드
        materialFile &&
          (await SaveLogic3(
            eduPathServer,
            materialFile,
            existingEduPaths[depCd]
          ));
      }
      dispatch(
        showSnackbar({
          message: '교육 자료가 성공적으로 등록되었습니다.',
          type: 'success',
        })
      );

      navigate('/M_TrainingPage');
    } catch (e) {
      console.error('저장 중 오류 발생:', e);
      dispatch(
        showSnackbar({
          message: e.message || '저장 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
      return false;
    } finally {
      setLoading(false);
    }
  };
  // DB 저장
  const saveToDB = async (depCd, vName, vPath, eName, ePath) => {
    try {
      const requestData = [
        {
          procedureName: 'SP_TRA_BASIC_04_U3',
          _CUST_CD: Commons.EncryptAES(searchRef.current.custCd),
          _DEP_CD: Commons.EncryptAES(depCd),
          _VIDEO_LOCATION: Commons.EncryptAES(vPath || ''),
          _VIDEO_FILE_NAME: Commons.EncryptAES(vName || ''),
          _EDU_LOCATION: Commons.EncryptAES(ePath || ''),
          _EDU_FILE_NAME: Commons.EncryptAES(eName || ''),
          _USER_ID: userInfo.userid,
        },
      ];

      const result = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        requestData
      );

      let isError = false;
      const data = result.data;

      if (Array.isArray(data)) {
        isError = data.some((item) => item.type === 'Error');
      } else if (data && data.type === 'Error') {
        isError = true;
      }

      if (isError) {
        // 배열일 경우 첫 메시지, 아니면 단일 메시지 출력
        const message = Array.isArray(data)
          ? data[0]?.message || 'DB 저장 오류'
          : data.message || 'DB 저장 오류';
        throw new Error(message);
      }

      return true;
    } catch (error) {
      console.error('saveToDB 오류:', error);
      dispatch(
        showSnackbar({
          message: error.message || 'DB 저장 실패',
          type: 'error',
        })
      );
      return false;
    }
  };

  // 동영상파일 파일서버에 저장
  const SaveLogic2 = async (_value1, _value2, oldFullPath) => {
    try {
      // 기존파일 삭제
      if (oldFullPath) {
        await MoveAndReplaceFile(oldFullPath, null, null, null);
      }
      const MAX_CHUNK_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB
      let finalSavePath = '';

      // ✅ 대용량 파일: 청크 업로드
      if (_value2.size > MAX_CHUNK_UPLOAD_SIZE) {
        finalSavePath = await UploadInChunks(_value1, _value2);
      }
      // ✅ 일반 파일 업로드
      else {
        const formData = new FormData();

        formData.append('UserId', userInfo.userid);
        formData.append('FilePath', _value1);
        formData.append('FormFile', _value2);

        const res = await Commons.Axios(
          'file2',
          Global.file.useUrl + Global.urls.Execute.videoUpload,
          null,
          formData
        );

        finalSavePath = res?.data?.filePath || '';
      }

      if (!finalSavePath) {
        dispatch(
          showSnackbar({
            message: '동영상파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      throw e; // ✅ 에러를 상위로 전파
    } finally {
    }
  };

  // 교육자료파일 파일서버에 저장
  const SaveLogic3 = async (_value1, _value2, oldFullPath) => {
    try {
      // 기존파일삭제
      if (oldFullPath) {
        await MoveAndReplaceFile(oldFullPath, null, null, null);
      }

      // 미리보기파일 삭제
      if (_value2) {
        const previewPath = `PreviewFiles/${_value2.name}`;
        await MoveAndReplaceFile(previewPath, null, null, null);
      }

      const MAX_CHUNK_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB
      let finalSavePath = '';

      // ✅ 대용량 파일: 청크 업로드
      if (_value2.size > MAX_CHUNK_UPLOAD_SIZE) {
        finalSavePath = await UploadInChunks(_value1, _value2);
      }
      // ✅ 일반 파일 업로드
      else {
        const formData = new FormData();

        formData.append('UserId', userInfo.userid);
        formData.append('FilePath', _value1);
        formData.append('FormFile', _value2);

        const res = await Commons.Axios(
          'file2',
          Global.file.useUrl + Global.urls.Execute.videoUpload,
          null,
          formData
        );

        finalSavePath = res?.data?.filePath || '';
      }

      if (!finalSavePath) {
        dispatch(
          showSnackbar({
            message: '파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }

      const savePath = finalSavePath.replace(/\\/g, '/');

      // PDF로 변환 가능한 파일 형식 확인 및 변환 ( moveAndReplaceFile 함수를 사용할 경우 옮기는 과정에서 파일이 깨짐. 폴더에 직접변환처리)
      const ext = _value2.name.split('.').pop()?.toLowerCase();
      const convertibleExts = [
        'hwp',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
      ];

      if (convertibleExts.includes(ext)) {
        const convertedUrl = await ConvertFileToPdf(savePath); // 실제 저장된 위치에서 변환!!!

        if (!convertedUrl) {
          dispatch(
            showSnackbar({
              message: `${ext.toUpperCase()} → PDF 변환 실패`,
              type: 'error',
            })
          );
          return savePath;
        }

        // 성공 시 PDF도 저장되었음
        // dispatch(showSnackbar({ message: 'HWP → PDF 변환 완료', type: 'success' }));
      }

      return savePath;
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      throw e; // ✅ 에러를 상위로 전파
    } finally {
    }
  };
  //#endregion

  //#region 나머지 함수
  //사업장 선택 핸들러
  const HandleWorkplaceChange = (event) => {
    setCustInfo({
      ...custInfo,
      custCd: event,
    });
    searchRef.current = {
      ...searchRef.current,
      custCd: event,
    };

    SearchLogic1();
  };

  // 부서 데이터 변환 함수(API 응답 데이터를 4단계 계층 구조로 변환)
  const ConvertDepartmentData = (apiData) => {
    const hierarchy = {
      headquarters: [],
      departments: [],
      teams: [],
      parts: [],
    };

    // 각 레벨별로 고유한 항목들을 수집
    const headquartersMap = new Map();
    const departmentsMap = new Map();
    const teamsMap = new Map();
    const partsMap = new Map();

    // 각 레벨별로 가장 마지막에 데이터가 있는 항목의 depCd를 저장하기 위한 Map
    const headquartersDepCdMap = new Map();
    const departmentsDepCdMap = new Map();
    const teamsDepCdMap = new Map();

    apiData.forEach((item) => {
      const { DEP_CD, DEP_NM1, DEP_NM2, DEP_NM3, DEP_NM4 } = item;

      // 본부 (DEP_NM1)
      if (DEP_NM1 && DEP_NM1.trim() !== '') {
        if (!headquartersMap.has(DEP_NM1)) {
          headquartersMap.set(DEP_NM1, {
            id: DEP_NM1,
            name: DEP_NM1,
            departments: [],
          });
        }
        // 본부 레벨의 depCd는 해당 본부가 최하위일 때만 설정 (DEP_NM2, DEP_NM3, DEP_NM4가 없을 때)
        if (
          (!DEP_NM2 || DEP_NM2.trim() === '') &&
          (!DEP_NM3 || DEP_NM3.trim() === '') &&
          (!DEP_NM4 || DEP_NM4.trim() === '')
        ) {
          headquartersDepCdMap.set(DEP_NM1, DEP_CD);
        }
      }

      // 부서 (DEP_NM2)
      if (DEP_NM2 && DEP_NM2.trim() !== '') {
        const deptKey = `${DEP_NM1}-${DEP_NM2}`;
        if (!departmentsMap.has(deptKey)) {
          departmentsMap.set(deptKey, {
            id: deptKey,
            name: DEP_NM2,
            parentId: DEP_NM1,
            teams: [],
          });
        }
        // 부서 레벨의 depCd는 해당 부서가 최하위일 때만 설정 (DEP_NM3, DEP_NM4가 없을 때)
        if (
          (!DEP_NM3 || DEP_NM3.trim() === '') &&
          (!DEP_NM4 || DEP_NM4.trim() === '')
        ) {
          departmentsDepCdMap.set(deptKey, DEP_CD);
        }
      }

      // 팀 (DEP_NM3)
      if (DEP_NM3 && DEP_NM3.trim() !== '') {
        const teamKey = `${DEP_NM1}-${DEP_NM2}-${DEP_NM3}`;
        if (!teamsMap.has(teamKey)) {
          teamsMap.set(teamKey, {
            id: teamKey,
            name: DEP_NM3,
            parentId: `${DEP_NM1}-${DEP_NM2}`,
            parts: [],
          });
        }
        // 팀 레벨의 depCd는 해당 팀이 최하위일 때만 설정 (DEP_NM4가 없을 때)
        if (!DEP_NM4 || DEP_NM4.trim() === '') {
          teamsDepCdMap.set(teamKey, DEP_CD);
        }
      }

      // 파트 (DEP_NM4)
      if (DEP_NM4 && DEP_NM4.trim() !== '') {
        const partKey = `${DEP_NM1}-${DEP_NM2}-${DEP_NM3}-${DEP_NM4}`;
        if (!partsMap.has(partKey)) {
          partsMap.set(partKey, {
            id: partKey,
            name: DEP_NM4,
            parentId: `${DEP_NM1}-${DEP_NM2}-${DEP_NM3}`,
            depCd: DEP_CD, // 파트는 직접 DEP_CD 사용
          });
        }
      }
    });

    // 각 레벨에 depCd 추가
    hierarchy.headquarters = Array.from(headquartersMap.values()).map((hq) => ({
      ...hq,
      depCd: headquartersDepCdMap.get(hq.id),
    }));

    hierarchy.departments = Array.from(departmentsMap.values()).map((dept) => ({
      ...dept,
      depCd: departmentsDepCdMap.get(dept.id),
    }));

    hierarchy.teams = Array.from(teamsMap.values()).map((team) => ({
      ...team,
      depCd: teamsDepCdMap.get(team.id),
    }));

    hierarchy.parts = Array.from(partsMap.values());

    return hierarchy;
  };

  //#region 파일 업로드 핸들러들
  const HandleVideoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setVideoFile(file);
      setVideoUrl(null); // 새 파일 업로드 시 서버 URL 초기화
    }
  };

  const HandleRemoveVideo = () => {
    setVideoFile(null);
    setVideoUrl(null);
  };

  const HandleMaterialUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const url = await UploadFileAndGetUrl(file); // <- 여기서 URL 받음

      if (url) {
        setMaterialFile(file); // 원본 파일 상태 저장
        setPreviewUrl(url); // 미리보기 URL
        // setPreviewFileName(file.name); // 파일명

        // // 파일 경로 저장
        // setEduLocation(path);
        // setEduFilePath(path);
        // setEduFileName(file.name);

        dispatch(
          showSnackbar({
            message: `${file.name} 파일 미리보기가 로딩되었습니다.`,
            type: 'info',
          })
        );
      } else {
        // setPreviewUrl('');
        dispatch(
          showSnackbar({
            message: `${file.name} 파일은 미리보기를 지원하지 않습니다.`,
            type: 'warning',
          })
        );
      }
    }
  };

  const HandleRemoveMaterial = () => {
    setMaterialFile(null);
    setPreviewUrl(null);
  };
  //#endregion

  //#region 아코디언 핸들러들
  const HandleHeadquartersCheckboxChange = (hqId, checked) => {
    if (checked) {
      setSelectedHeadquarters([...selectedHeadquarters, hqId]);
    } else {
      // 본부 제거 시 관련 하위 선택들도 제거
      const newHeadquarters = selectedHeadquarters.filter((id) => id !== hqId);
      setSelectedHeadquarters(newHeadquarters);

      // 제거된 본부의 하위 부서들 제거
      const departmentsToRemove = departmentData.departments
        .filter((dept) => dept.parentId === hqId)
        .map((dept) => dept.id);

      const newDepartments = selectedDepartments.filter(
        (deptId) => !departmentsToRemove.includes(deptId)
      );
      setSelectedDepartments(newDepartments);

      // 제거된 본부의 하위 팀들 제거 (부서를 통해)
      const teamsToRemove = departmentData.teams
        .filter((team) => {
          const dept = departmentData.departments.find(
            (d) => d.id === team.parentId
          );
          return dept && dept.parentId === hqId;
        })
        .map((team) => team.id);

      const newTeams = selectedTeams.filter(
        (teamId) => !teamsToRemove.includes(teamId)
      );
      setSelectedTeams(newTeams);

      // 제거된 본부의 하위 파트들 제거 (팀을 통해)
      const partsToRemove = departmentData.parts
        .filter((part) => {
          const team = departmentData.teams.find((t) => t.id === part.parentId);
          if (team) {
            const dept = departmentData.departments.find(
              (d) => d.id === team.parentId
            );
            return dept && dept.parentId === hqId;
          }
          return false;
        })
        .map((part) => part.id);

      const newParts = selectedParts.filter(
        (partId) => !partsToRemove.includes(partId)
      );
      setSelectedParts(newParts);
    }
  };

  const HandleDepartmentCheckboxChange = (deptId, checked) => {
    if (checked) {
      setSelectedDepartments([...selectedDepartments, deptId]);
    } else {
      // 부서 제거 시 관련 하위 선택들도 제거
      const newDepartments = selectedDepartments.filter((id) => id !== deptId);
      setSelectedDepartments(newDepartments);

      // 제거된 부서의 하위 팀들 제거
      const teamsToRemove = departmentData.teams
        .filter((team) => team.parentId === deptId)
        .map((team) => team.id);

      const newTeams = selectedTeams.filter(
        (teamId) => !teamsToRemove.includes(teamId)
      );
      setSelectedTeams(newTeams);

      // 제거된 부서의 하위 파트들 제거 (팀을 통해)
      const partsToRemove = departmentData.parts
        .filter((part) => {
          const team = departmentData.teams.find((t) => t.id === part.parentId);
          return team && team.parentId === deptId;
        })
        .map((part) => part.id);

      const newParts = selectedParts.filter(
        (partId) => !partsToRemove.includes(partId)
      );
      setSelectedParts(newParts);
    }
  };

  const HandleTeamCheckboxChange = (teamId, checked) => {
    if (checked) {
      setSelectedTeams([...selectedTeams, teamId]);
    } else {
      // 팀 제거 시 관련 하위 선택들도 제거
      const newTeams = selectedTeams.filter((id) => id !== teamId);
      setSelectedTeams(newTeams);

      // 제거된 팀의 하위 파트들 제거
      const partsToRemove = departmentData.parts
        .filter((part) => part.parentId === teamId)
        .map((part) => part.id);

      const newParts = selectedParts.filter(
        (partId) => !partsToRemove.includes(partId)
      );
      setSelectedParts(newParts);
    }
  };

  const HandlePartCheckboxChange = (partId, checked) => {
    if (checked) {
      setSelectedParts([...selectedParts, partId]);
    } else {
      setSelectedParts(selectedParts.filter((id) => id !== partId));
    }
  };
  //#endregion

  //#region 동적 필터링 함수들
  const GetAvailableDepartments = () => {
    // 선택된 본부에 속한 부서들만 반환
    return departmentData.departments.filter((dept) =>
      selectedHeadquarters.includes(dept.parentId)
    );
  };

  const GetAvailableTeams = () => {
    // 선택된 부서에 속한 팀들만 반환
    return departmentData.teams.filter((team) =>
      selectedDepartments.includes(team.parentId)
    );
  };

  const GetAvailableParts = () => {
    // 선택된 팀에 속한 파트들만 반환
    return departmentData.parts.filter((part) =>
      selectedTeams.includes(part.parentId)
    );
  };
  //#endregion

  //#region 교육 자료 미리보기 함수
  // 파일 URL 얻기
  const GetFullFileUrl = (relativePath) => {
    if (!relativePath) return '';
    const fixedPath = FixUrl(relativePath);
    const fullUrl = `${Global.file.useUrl}files/${fixedPath}`;
    return fullUrl;
  };

  // URL 인코딩 처리
  const FixUrl = (url) => {
    if (!url || typeof url !== 'string') return '';
    const parts = url.split('/');
    const fileName = parts.pop();
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };

  // 파일 선택 후 처리
  const MoveAndReplaceFile = async (
    oldFilePath, // 기존 파일 경로 (이전 파일 위치, 없으면 빈 문자열)
    sourcePreviewPath, // 현재 파일 위치 (임시 경로 등, 미리보기 경로)
    newFileName, // 새로 저장할 파일명
    targetPath // 최종 저장할 디렉터리 경로 (예: Education/고객코드/부서코드/DEP_BASIC)
  ) => {
    try {
      const payload = {
        oldFilePath,
        sourcePreviewPath,
        newFileName,
        targetPath,
      };

      const { data } = await Commons.Axios(
        'post1',
        Global.file.useUrl + Global.urls.Execute.moveAndReplaceFile,
        payload
      );

      if (!data || data.type === 'Error') {
        throw new Error(data?.message || '파일 이동 실패');
      }

      return data; // 성공 시 서버 응답 반환 (true 등)
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e.message || '파일 저장 실패',
          type: 'error',
        })
      );
      console.error('MoveAndReplaceFile Error:', e);
      return null; // 실패 시 null 반환
    }
  };

  // 서버에 파일 업로드 후 URL 얻기
  const UploadFileAndGetUrl = async (file) => {
    const ext = file.name.split('.').pop().toLowerCase();

    let uploadedFilePath;

    if (ext === 'pdf') {
      const arrayBuffer = await file.arrayBuffer();
      const pdfDoc = await PDFDocument.load(arrayBuffer);
      pdfDoc.setTitle(file.name);
      const modifiedBytes = await pdfDoc.save();
      const modifiedFile = new File(
        [new Blob([modifiedBytes], { type: 'application/pdf' })],
        file.name,
        { type: 'application/pdf' }
      );
      uploadedFilePath = await UploadFile(modifiedFile);
      // PDF URL이거나 원본 경로일 수 있으므로 FixUrl 적용
      return FixUrl(uploadedFilePath);
    } else {
      uploadedFilePath = await UploadFile(file);
      // PDF URL이거나 원본 경로일 수 있으므로 FixUrl 적용
      return FixUrl(uploadedFilePath);
    }
  };

  // 실제 파일 업로드 API 호출
  const UploadFile = async (_file) => {
    setLoading(true);

    const MAX_CHUNK_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB
    const filePath = 'PreviewFiles';
    let finalSavePath = '';

    try {
      if (_file.size > MAX_CHUNK_UPLOAD_SIZE) {
        // 대용량 파일: 청크 업로드
        finalSavePath = await UploadInChunks(_file);
      } else {
        // 일반 파일 업로드
        const formData = new FormData();
        formData.append('UserId', userInfo.userid);
        formData.append('FilePath', filePath);
        formData.append('FormFile', _file);

        const result = await Commons.Axios(
          'file2',
          Global.file.useUrl + Global.urls.Execute.videoUpload,
          null,
          formData
        );

        finalSavePath = result?.data?.filePath || '';
      }

      if (!finalSavePath) {
        dispatch(
          showSnackbar({
            message: '파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      } else {
        const cleanedPath = finalSavePath
          .replace(/^.*\\PreviewFiles/, 'PreviewFiles')
          .replace(/\\/g, '/');

        const ext = _file.name.split('.').pop()?.toLowerCase();

        // PDF로 변환 가능한 파일 형식: 한글, 워드, 엑셀, 파워포인트
        const convertibleExts = [
          'hwp',
          'doc',
          'docx',
          'xls',
          'xlsx',
          'ppt',
          'pptx',
        ];

        if (convertibleExts.includes(ext)) {
          const pdfUrl = await ConvertFileToPdf(cleanedPath);
          return pdfUrl || null;
        }

        // PDF 파일과 이미지 파일은 그대로 반환
        return cleanedPath;
      }
    } catch (error) {
      dispatch(showSnackbar({ message: error.message, type: 'error' }));
      return null;
    } finally {
      setLoading(false);
    }
  };

  // 파일 확장자 추출 헬퍼
  const GetExtension = (url) => {
    if (!url) return '';
    const name = url.split('/').pop();
    return name?.split('.').pop().toLowerCase() || '';
  };

  // 미리보기 렌더 함수 (previewUrl 기반)
  const RenderPreview = () => {
    if (!previewUrl) return <div>미리보기 영역</div>;

    const ext = GetExtension(previewUrl);
    const fullUrl = Global.file.useUrl + 'files/' + previewUrl;

    if (['png', 'jpg', 'jpeg'].includes(ext)) {
      return (
        <img
          src={fullUrl}
          alt="미리보기"
          style={{
            maxWidth: '100%',
            minHeight: '300px',
            maxHeight: '600px',
            objectFit: 'contain',
          }}
        />
      );
    }

    if (
      ['pdf', 'hwp', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].includes(ext)
    ) {
      const pdfUrl =
        ext !== 'pdf'
          ? fullUrl.replace(/\.(hwp|doc|docx|ppt|pptx|xls|xlsx)$/i, '.pdf')
          : fullUrl;

      return (
        <iframe
          src={pdfUrl}
          title="PDF 미리보기"
          allow="fullscreen"
          style={{ width: '100%', minHeight: '300px', maxHeight: '600px' }}
        />
      );
    }

    return <div>지원하지 않는 형식입니다.</div>;
  };

  const UploadInChunks = async (
    filePath,
    file,
    chunkSize = 5 * 1024 * 1024
  ) => {
    const totalChunks = Math.ceil(file.size / chunkSize);
    const saveName = file.name;

    for (let i = 0; i < totalChunks; i++) {
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const chunk = file.slice(start, end);

      const formData = new FormData();
      formData.append('chunk', chunk);
      formData.append('chunkIndex', i);
      formData.append('totalChunks', totalChunks);
      formData.append('fileName', saveName);
      formData.append('UserId', userInfo.userid);
      formData.append('FilePath', filePath);

      await Commons.Axios(
        'chunk',
        Global.file.useUrl + Global.urls.Execute.UploadChunk,
        null,
        formData
      );
    }

    // 병합 요청
    const mergeResponse = await Commons.Axios(
      'post',
      Global.file.useUrl + Global.urls.Execute.MergeChunks,
      null, // 쿼리스트링 없음
      {
        fileName: saveName,
        filePath,
        userId: userInfo.userid,
      }
    );

    return mergeResponse?.data?.filePath || '';
  };

  // 파일 확장자에 따른 PDF 변환 함수
  const ConvertFileToPdf = async (_filePath) => {
    if (!_filePath) {
      console.error('ConvertFileToPdf: filePath가 없습니다.');
      return null;
    }

    try {
      const payload = { FilePath: _filePath };

      // 파일 경로에서 확장자 추출
      const fileName =
        _filePath.split('/').pop() || _filePath.split('\\').pop();
      const ext = fileName.split('.').pop()?.toLowerCase();

      // 확장자에 따라 다른 변환 API 선택
      let convertApiUrl = '';
      switch (ext) {
        case 'hwp':
          convertApiUrl = Global.urls.Execute.ConvertHwpToPdf;
          break;
        case 'doc':
        case 'docx':
        case 'xls':
        case 'xlsx':
        case 'ppt':
        case 'pptx':
          convertApiUrl = Global.urls.Execute.ConvertOfficeToPdf;
          break;
        default:
          console.error(
            `ConvertFileToPdf: 지원하지 않는 파일 형식입니다: ${ext}`
          );
          return null;
      }

      const response = await Commons.Axios(
        'post1',
        Global.file.useUrl + convertApiUrl,
        payload
      );

      // 서버 응답 검증
      if (response?.data?.url) {
        return response.data.url;
        // 서버가 '/PreviewFiles/xxx.pdf' 형태로 반환하면 'files/PreviewFiles/xxx.pdf'
      } else {
        console.error('ConvertFileToPdf: 서버 응답이 유효하지 않음', response);
        return null;
      }
    } catch (error) {
      console.error('ConvertFileToPdf: 요청 중 오류 발생', error);
      return null;
    }
  };
  //#endregion

  // 등록 대상 목록에 표시할 최종 선택 항목들 계산
  const GetFinalSelectedItems = () => {
    const finalItems = [];

    // 1. 선택된 파트들 추가 (최하위 레벨)
    selectedParts.forEach((partId) => {
      const part = departmentData.parts.find((p) => p.id === partId);
      if (part) {
        finalItems.push({
          id: part.id,
          name: part.name,
          level: 'part',
          color: '#F57C00',
          backgroundColor: '#FFF3E0',
          depCd: part.depCd, // 파트의 DEP_CD 포함
        });
      }
    });

    // 2. 파트가 선택되지 않은 팀들 추가
    selectedTeams.forEach((teamId) => {
      const team = departmentData.teams.find((t) => t.id === teamId);
      if (team) {
        // 해당 팀에 선택된 파트가 있는지 확인
        const hasSelectedParts = selectedParts.some((partId) => {
          const part = departmentData.parts.find((p) => p.id === partId);
          return part && part.parentId === teamId;
        });

        if (!hasSelectedParts) {
          finalItems.push({
            id: team.id,
            name: team.name,
            level: 'team',
            color: '#0D843F',
            backgroundColor: '#E8F5E8',
            depCd: team.depCd, // 이제 팀에도 depCd가 있음
          });
        }
      }
    });

    // 3. 팀이 선택되지 않은 부서들 추가
    selectedDepartments.forEach((deptId) => {
      const dept = departmentData.departments.find((d) => d.id === deptId);
      if (dept) {
        // 해당 부서에 선택된 팀이나 파트가 있는지 확인
        const hasSelectedTeams = selectedTeams.some((teamId) => {
          const team = departmentData.teams.find((t) => t.id === teamId);
          return team && team.parentId === deptId;
        });

        const hasSelectedParts = selectedParts.some((partId) => {
          const part = departmentData.parts.find((p) => p.id === partId);
          if (part) {
            const team = departmentData.teams.find(
              (t) => t.id === part.parentId
            );
            return team && team.parentId === deptId;
          }
          return false;
        });

        if (!hasSelectedTeams && !hasSelectedParts) {
          finalItems.push({
            id: dept.id,
            name: dept.name,
            level: 'department',
            color: '#7B1FA2',
            backgroundColor: '#F3E5F5',
            depCd: dept.depCd, // 이제 부서에도 depCd가 있음
          });
        }
      }
    });

    // 4. 부서가 선택되지 않은 본부들 추가
    selectedHeadquarters.forEach((hqId) => {
      const hq = departmentData.headquarters.find((h) => h.id === hqId);
      if (hq) {
        // 해당 본부에 선택된 부서, 팀, 파트가 있는지 확인
        const hasSelectedDepts = selectedDepartments.some((deptId) => {
          const dept = departmentData.departments.find((d) => d.id === deptId);
          return dept && dept.parentId === hqId;
        });

        const hasSelectedTeams = selectedTeams.some((teamId) => {
          const team = departmentData.teams.find((t) => t.id === teamId);
          if (team) {
            const dept = departmentData.departments.find(
              (d) => d.id === team.parentId
            );
            return dept && dept.parentId === hqId;
          }
          return false;
        });

        const hasSelectedParts = selectedParts.some((partId) => {
          const part = departmentData.parts.find((p) => p.id === partId);
          if (part) {
            const team = departmentData.teams.find(
              (t) => t.id === part.parentId
            );
            if (team) {
              const dept = departmentData.departments.find(
                (d) => d.id === team.parentId
              );
              return dept && dept.parentId === hqId;
            }
          }
          return false;
        });

        if (!hasSelectedDepts && !hasSelectedTeams && !hasSelectedParts) {
          finalItems.push({
            id: hq.id,
            name: hq.name,
            level: 'headquarters',
            color: '#42A5F5',
            backgroundColor: '#E3F2FD',
            depCd: hq.depCd, // 이제 본부에도 depCd가 있음
          });
        }
      }
    });

    // 레벨별 정렬: 본부 → 부서 → 팀 → 파트 순
    const levelOrder = {
      headquarters: 1,
      department: 2,
      team: 3,
      part: 4,
    };

    return finalItems.sort((a, b) => {
      // 먼저 레벨별로 정렬
      const levelDiff = levelOrder[a.level] - levelOrder[b.level];
      if (levelDiff !== 0) {
        return levelDiff;
      }
      // 같은 레벨 내에서는 이름으로 정렬
      return a.name.localeCompare(b.name);
    });
  };

  // 최종선택된 DEP_CD  추출 (상위 부서 선택 시 하위 부서들도 포함)
  const GetExportDepCds = () => {
    const finalItems = GetFinalSelectedItems(); // Chip에 보여지는 항목
    const depCds = new Set();

    for (const item of finalItems) {
      // 선택된 항목의 depCd 추가
      if (item.depCd) {
        depCds.add(item.depCd);
      }

      // 상위 부서 선택 시 하위 부서들의 depCd도 모두 추가
      if (item.level === 'headquarters') {
        // 본부 선택 시: 해당 본부의 모든 부서, 팀, 파트의 depCd 추가
        departmentData.departments
          .filter((dept) => dept.parentId === item.id)
          .forEach((dept) => {
            if (dept.depCd) depCds.add(dept.depCd);
          });

        departmentData.teams
          .filter((team) => {
            const dept = departmentData.departments.find(
              (d) => d.id === team.parentId
            );
            return dept && dept.parentId === item.id;
          })
          .forEach((team) => {
            if (team.depCd) depCds.add(team.depCd);
          });

        departmentData.parts
          .filter((part) => {
            const team = departmentData.teams.find(
              (t) => t.id === part.parentId
            );
            if (team) {
              const dept = departmentData.departments.find(
                (d) => d.id === team.parentId
              );
              return dept && dept.parentId === item.id;
            }
            return false;
          })
          .forEach((part) => {
            if (part.depCd) depCds.add(part.depCd);
          });
      } else if (item.level === 'department') {
        // 부서 선택 시: 해당 부서의 모든 팀, 파트의 depCd 추가
        departmentData.teams
          .filter((team) => team.parentId === item.id)
          .forEach((team) => {
            if (team.depCd) depCds.add(team.depCd);
          });

        departmentData.parts
          .filter((part) => {
            const team = departmentData.teams.find(
              (t) => t.id === part.parentId
            );
            return team && team.parentId === item.id;
          })
          .forEach((part) => {
            if (part.depCd) depCds.add(part.depCd);
          });
      } else if (item.level === 'team') {
        // 팀 선택 시: 해당 팀의 모든 파트의 depCd 추가
        departmentData.parts
          .filter((part) => part.parentId === item.id)
          .forEach((part) => {
            if (part.depCd) depCds.add(part.depCd);
          });
      }
      // 파트 선택 시는 이미 위에서 추가됨
    }

    return Array.from(depCds);
  };
  //#endregion

  return (
    <div className="wrap">
      <M_TRA_BASIC_03
        ToggleDrawer={ToggleDrawer}
        bottomSheetState={bottomSheetState}
        id={id}
        custInfo={custInfo}
        videoFile={videoFile}
        videoUrl={videoUrl}
        materialFile={materialFile}
        previewUrl={previewUrl}
        selectedHeadquarters={selectedHeadquarters}
        selectedDepartments={selectedDepartments}
        selectedTeams={selectedTeams}
        selectedParts={selectedParts}
        departmentData={departmentData}
        videoInputRef={videoInputRef}
        materialInputRef={materialInputRef}
        // 함수
        dispatch={dispatch}
        HandleSave={HandleSave}
        HandleWorkplaceChange={HandleWorkplaceChange}
        HandleVideoUpload={HandleVideoUpload}
        HandleRemoveVideo={HandleRemoveVideo}
        HandleMaterialUpload={HandleMaterialUpload}
        HandleRemoveMaterial={HandleRemoveMaterial}
        HandleHeadquartersCheckboxChange={HandleHeadquartersCheckboxChange}
        HandleDepartmentCheckboxChange={HandleDepartmentCheckboxChange}
        HandleTeamCheckboxChange={HandleTeamCheckboxChange}
        HandlePartCheckboxChange={HandlePartCheckboxChange}
        GetFinalSelectedItems={GetFinalSelectedItems}
        GetAvailableDepartments={GetAvailableDepartments}
        GetAvailableTeams={GetAvailableTeams}
        GetAvailableParts={GetAvailableParts}
        RenderPreview={RenderPreview}
      />
      <Loading open={loading} />
    </div>
  );
}

export default M_TRA_BASIC_03F;
